var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"img-box",style:({height: _vm.boxHeight, backgroundColor: _vm.boxHeight ? '#efefef' : 'transparent'})},[_c('img',{ref:"img",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }